import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/auth-context'

/** OAuth redirect target after Cognito Hosted UI sign-in */
export function AuthCallbackPage() {
  const { refresh } = useAuth()
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      try {
        await refresh()
        if (!cancelled) navigate('/messages/direct', { replace: true })
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : 'Authentication failed')
        }
      }
    })()
    return () => {
      cancelled = true
    }
  }, [refresh, navigate])

  return (
    <div style={{ padding: 48, textAlign: 'center' }}>
      {error ? <p style={{ color: '#dc2626' }}>{error}</p> : <p>Completing sign in…</p>}
    </div>
  )
}
